import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgEmergencyLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#F0F0F0"
    />
    <path
      d="M17 12H7M12 7V17"
      stroke="#CA0D0D"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgEmergencyLarge.displayName = 'SvgEmergencyLarge';
const EmergencyLarge = withForgeIconProps(SvgEmergencyLarge, {
  name: 'Emergency',
  usage:
    'Use to indicate emergency information, like an urgent care location or an emergency contact.',
  related: 'alert, 911',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default EmergencyLarge;
